import React, {useEffect} from 'react'
import styles from './styles.module.scss'
import Modal from "react-modal";
import branchApi from "../../../../store/branchStore/branchApi";
import * as Yup from 'yup';
import closeModalImage from "../../../../components/PayModal/assets/CloseModalIcon.svg";
import ButtonFilled from "../../../../components/FormElements/ButtonFilled";
import {useTranslation} from "react-i18next";
import { store } from "react-notifications-component";
import TextField from "../../../../components/FormElements/TextField";
import {PhoneInputField} from "../../../../components/PhoneInput";
import {CustomSingleDatePicker} from "../../../../components/CustomDatePicker/CustomDatePicker";
import {useFormik} from "formik";
import {onlyDigits} from "../../../../helpers";
import {useDispatch, useSelector} from "react-redux";
import clientsActions from "../../../../store/clientsStore/clientsActions";
import {convertDate} from "../../../../tools/convertDateToString";

const ImportUserModal = (props) => {
  const { t } = useTranslation();
  const branch = useSelector(s => s.branchReducer);
  const dispatch = useDispatch()

  useEffect(() => {
    if (branch.info && !branch.pending) {
      formik.setFieldValue('name', '');
      formik.setFieldValue('bonus', '');
      formik.setFieldValue('first_name', '');
      formik.setFieldValue('last_name', '');
      formik.setFieldValue('phone', '');
      formik.setFieldValue('birth_date', '');
    }
  }, [branch]);

  const formik = useFormik({
    initialValues: {
      birth_date: '',
      bonus: '',
      first_name: '',
      last_name: '',
      phone: ''
    },
    validationSchema: Yup.object({
      bonus: Yup.string().required(t('Form.fillField')),
      first_name: Yup.string().required(t('Form.fillField')),
      last_name: Yup.string().required(t('Form.fillField')),
      phone: Yup.string().required(t('Form.fillField')),
      birth_date: Yup.string().nullable(),
    }),
    onSubmit: (async (values, { setSubmitting }) => {

      const phone = `+${onlyDigits(values.phone)}`;

      try {
        let data = {
          ...values,
          bonus: Number(values.bonus),
          birth_date: values.birth_date ? convertDate(values.birth_date) : '',
          phone
        }

        await branchApi.branchesCustomersUploadUser(branch.info.id, data)
        dispatch(clientsActions.changeParams({
          page: 1,
          skip: 0,
        }))

        store.addNotification({
          title: t('success'),
          message: t('changesSaved'),
          type: "success",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });
        props.onRequestClose()
      } catch (e) {
        const res = e.response ? e.response.data : null;

        store.addNotification({
          title: `Error code: ${res ? res.code : 'NULL'}`,
          message: `${res ? res.message : t('Notify.notRespond')}`,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 5000,
            onScreen: true
          }
        });

      }
    })
  });

  return (
    <Modal
      {...props}
    >
      <form onSubmit={formik.handleSubmit} className={styles.modal}>
        <div className={styles.closeModal} onClick={props.onRequestClose}>
          <img src={closeModalImage}/>
        </div>
        <div className={styles.modalContainer}>
          <TextField
            label={t('Form.firstName')}

            value={formik.values.first_name}
            error={formik.touched.first_name && formik.errors.first_name}
            onChange={(e) => formik.setFieldValue('first_name', e.target.value)}
          />
          <TextField
            label={t('Form.lastName')}

            value={formik.values.last_name}
            error={formik.touched.last_name && formik.errors.last_name}
            onChange={(e) => formik.setFieldValue('last_name', e.target.value)}
          />
          <div style={{ height: 16 }}></div>
          <div>
            <p>{t('NSBonus.birthday')}</p>
            <CustomSingleDatePicker
              tSetDate={(date) => formik.setFieldValue("birth_date", date)}
              tDate={formik.values.birth_date}
              portalId="datepicker-root"
              popperProps={{ positionFixed: true }}
            />
            {formik.touched.birth_date && formik.errors.birth_date ? (
              <p style={{ color: 'tomato' }}>{formik.errors.birth_date}</p>
            ) : null}
          </div>
          <div style={{ height: 16 }}></div>
          <TextField
            type="number"
            label={t('bonus')}

            value={formik.values.bonus}
            error={formik.touched.bonus && formik.errors.bonus}
            onChange={(e) => formik.setFieldValue('bonus', e.target.value)}
          />


          <div style={{ height: 16 }}></div>
          <PhoneInputField
            label={t('contacts')}
            error={!!formik.touched.phone && !!formik.errors.phone}
            onChange={(v) => formik.setFieldValue("phone", v)}
            value={formik.values.phone}
            required
          />

          <div style={{ marginTop: '30px', display: 'flex', justifyContent: 'center' }}>
            <ButtonFilled
              type="submit"
              loading={formik.isSubmitting}
            >
              {t('save')}
            </ButtonFilled>
          </div>
        </div>
      </form>
    </Modal>
  )
}

export default ImportUserModal